import Button from "@mui/material/Button";
import FormGroup from "@mui/material/FormGroup";
import TextField from "@mui/material/TextField";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { get, post, put } from "../../../utils/api";
import { startCase } from "lodash";
import PhoneInput from "react-phone-input-2"; // Import phone input component
import "react-phone-input-2/lib/style.css"; // Import the required styles
import ModuleFieldsMultiSelect from "../../multi-select";
import MultiSelectV2 from "../../multi-select-v2";
import Select from "../../select";
import Select2 from "../../select-v2";
import KeyValueSelect from "../../../modules/home/permission-matrix/new";
import ModuleFieldsKeyValueSelect from "../../keyvalue-select";
import ModuleFieldsKeyValueSelectV2 from "../../keyvalue-select-v2";
import FileInput from "../../file-input-edit";
import FileInputNew from "../../file-input-new";
import { generate_presigned_urls } from "../../common";

export default function NewModule(props: any) {
  const navigate = useNavigate();
  const [snackbar, setSnackbar] = useState(false);
  const [alert_severity, setAlertSeverity] = useState("warning");
  const [alert_message, setMessage] = useState("");
  const [formData, setFormData] = useState<any>({});
  const [fields, setFields] = useState<Array<any>>([]);
  const [defaultCountry, setDefaultCountry] = useState<string>("in"); // Default to 'us' in case country detection fails
  const [selectedFiles, setSelectedFiles] = useState<Array<any>>([]);
  const [selectedFieldKeys, setSelectedFieldKeys] = useState('');

  useEffect(() => {
    getFields();
    // detectCountryFromLocale(); // Detect the user's country based on locale
  }, [props.module]);

  const getFields = async () => {
    try {
      const response = await get(`${props.module}`, {});
      setFields(response.data.fields);
    } catch (error) {
      console.log("Error fetching fields: ", error);
    }
  };

  // const detectCountryFromLocale = () => {
  //   // Use navigator.language to detect user's locale
  //   const userLanguage = navigator.language || navigator.language;

  //   if (userLanguage) {
  //     // Split the language into language and country (e.g., "en-US" -> "us")
  //     const localeParts = userLanguage.split("-");
  //     console.log("userLanguage",userLanguage)
  //     if (localeParts.length === 2) {
  //       setDefaultCountry(localeParts[1].toLowerCase());
  //     }
  //   }
  // };

  const handleSubmit = async (e: any) => {
    e.preventDefault();
    try {
      const response = await post(props.module, formData);
      console.log("res", response)
      if (response) {
        if(selectedFiles.length==0){
          navigate(`/${props.module}/list`);
        }else{
          UploadFiletos3(response)
        }        
      }
    } catch (error) {
      console.error("Error submitting form: ", error);
    }
  };

  const UploadFiletos3=async (response:any)=>{
    console.log("sel", selectedFiles)
    const fileNames = selectedFiles.map((file) => file.name);
    let data={
      module:props.module,
      primary_id : response.job_enquiry_id
    }
    let uploaded_files:any =await generate_presigned_urls([],fileNames, selectedFiles, data, 'new');
    console.log("uploaded_files", uploaded_files, selectedFieldKeys)
    if (!selectedFieldKeys || typeof selectedFieldKeys !== 'string') {
      console.error("selectedFieldKeys is invalid.");
      return;
    }
    // formData['client_files']=uploaded_files;
    await setFormData((prev: any) => ({
      ...prev,
      [selectedFieldKeys]: uploaded_files, // Ensure this updates 'client_files'
    }));
      await updateData(response.client_id, uploaded_files);
    
    
  }

  const updateData=async (id:any, uploaded_files:any)=>{
    try {
        let data:any ={
          [selectedFieldKeys] : uploaded_files
        }    
      await put(`${props.module}/${id}`, data);
      // navigate(`${props.modulePath}/list`);
    } catch (error) {
      console.error("Failed to update data:", error);
    }
  }

  const handleChange = (e: any) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };
  const handleMultiSelectChange = (selectedOptions:any, fieldName:any) => {
    setFormData({ ...formData, [fieldName]: selectedOptions.map((option:any) => option.value) });
  };

  const handleSelectChange = (selectedOption:any, fieldName:any) => {
    setFormData({ ...formData, [fieldName]: selectedOption });
  };

  const handleKeyValueSelectChange = (selectedOptions: any, fieldName: any) => {
    console.log("Selected Options:", selectedOptions); // Log selected options to verify structure
    console.log("Field Name:", fieldName);       // Log fieldName to ensure correct field is being updated
    setFormData({ ...formData, [fieldName]: selectedOptions });
  };
    
  
  

  const handlePhoneChange = (value: string, name: string) => {
    setFormData({ ...formData, [name]: value });
  };

  const alert = (message: string, alert_severity: string = "warning") => {
    setSnackbar(true);
    setMessage(message);
    setAlertSeverity(alert_severity);
  };

  const closeSnackbar = () => {
    setSnackbar(false);
  };


  const handleFilesChange = (files: any[], fieldKey: string) => {
    setSelectedFiles(files);
    setSelectedFieldKeys(fieldKey)
    // setFormData((prev:any) => ({ ...prev, [fieldKey]: files })); // Update the relevant field in formData
    console.log("files-fieldkey", files, fieldKey);
  };

  const isEmailField = (key: string) => key.toLowerCase().includes("email");
  const isPhoneNumberField = (key: string) =>
    key.toLowerCase().includes("phone") ||
    key.toLowerCase().includes("whatsapp");

  return (
    <>
      <div
        className="container"
        style={{ marginTop: "22px", marginBottom: "200px",paddingLeft: "20px" }}
      >
        <div className="row new-client-header">
          <div className="col-xs-12">
            <h5>{"New " + startCase(props.module)}</h5>
          </div>
        </div>

        <form onSubmit={handleSubmit}>
          {fields
            .filter((field: any) => field.create_status === true)
            .map((field) => (
              <div key={field.key} className="row mt-3 mb-3">
                <div className="col-xs-12 col-md-4 col-lg-4 d-flex align-items-center">
                  <label htmlFor={field.key}>
                    {startCase(field.key.replaceAll("_", " "))}
                  </label>
                </div>
                <div className="col-xs-12 col-md-8 col-lg-8">
                  <FormGroup>
                    {isEmailField(field.key) ? (
                      <TextField
                        sx={{ width: "100%" }}
                        fullWidth
                        type="email" // Set type to email
                        name={field.key}
                        value={formData[field.key] || ""}
                        onChange={handleChange}
                        placeholder={startCase(field.key.replaceAll("_", " "))}
                        required={field.required || false}
                      />
                    ) : isPhoneNumberField(field.key) ? (
                      <PhoneInput
                        country={defaultCountry} // Set the detected country code
                        value={formData[field.key] || ""}
                        onChange={(value: string) =>
                          handlePhoneChange(value, field.key)
                        }
                        inputStyle={{ width: "100%", borderRadius: "4px" }} // Enhance the UI with rounded borders
                        buttonStyle={{ borderRadius: "4px" }}
                        enableSearch={true} // Add country search functionality
                      />
                    ) : field.type === "String" ? (
                      <TextField
                        sx={{ width: "100%" }}
                        fullWidth
                        name={field.key}
                        value={formData[field.key] || ""}
                        onChange={handleChange}
                        placeholder={startCase(field.key.replaceAll("_", " "))}
                        required={field.required || false}
                      />
                    ) : field.type === "Number" ? (
                      <TextField
                        sx={{ width: "100%" }}
                        fullWidth
                        type="number"
                        name={field.key}
                        value={formData[field.key] || ""}
                        onChange={handleChange}
                        placeholder={startCase(field.key.replaceAll("_", " "))}
                        required={field.required || false}
                      />
                    ) : field.type === "Date" ? (
                      <TextField
                        sx={{ width: "100%" }}
                        fullWidth
                        type="date"
                        name={field.key}
                        value={formData[field.key] || ""}
                        onChange={handleChange}
                        required={field.required || false}
                      />
                    ): 
                    field.type === "Object" && field.ui_element_type=="file-input"?(
                            <FileInputNew  onFileChange={(files: any) => handleFilesChange(files, field.key)} />         
                    ):field.type === "Object" && field.ui_element_type=="multi-select"?(
                      <MultiSelectV2 
                      properties={field.properties}  
                      formData={formData}
                      values={formData[field.key] || []} // Use existing value or fallback to an empty array
                      onChange={(selectedOptions:any) => handleSelectChange(selectedOptions, field.key)}
                    />    
                    // <></>
                     ): 
                    field.type === "Object" && field.ui_element_type=="select"?(
                      <Select2 
                      properties={field.properties}  
                      formData={formData}
                      value={formData[field.key] || []} // Use existing value or fallback to an empty array
                      onChange={(selectedOptions:any) => handleSelectChange(selectedOptions, field.key)}
                    />    
                    // <></>
                     ): 
                     field.type === "Object" && field.ui_element_type=="key-value-select-v2"?(
                      <ModuleFieldsKeyValueSelectV2 
                          formData={formData}
                          properties={field.properties}  
                          values={formData[field.key] || []} // Use existing value or fallback to an empty array
                          onChange={(selectedOptions) => handleKeyValueSelectChange(selectedOptions, field.key)}
                        />
                                  
                    ):
                    field.type === "Object" && field.ui_element_type=="key-value-select"?(
                      <ModuleFieldsKeyValueSelect 
                          properties={field.properties}  
                          values={formData[field.key] || []} // Use existing value or fallback to an empty array
                          onChange={(selectedOptions) => handleKeyValueSelectChange(selectedOptions, field.key)}
                        />
                                  
                    )  : field.type === "Object" && field.mapped_collection && !field.mapped_collection.multiple?(
                      <Select
                      value={formData[field.key] || []} // Use existing value or fallback to an empty array
                      mapped_collection={field.mapped_collection}
                      onChange={(selectedOptions:any) => handleSelectChange(selectedOptions, field.key)}
                    />
                    ) : field.type === "Object" && field.mapped_collection? (
                      <ModuleFieldsMultiSelect
                      values={formData[field.key] || []} 
                      mapped_collection={field.mapped_collection}
                      onChange={(selectedOptions:any) => handleSelectChange(selectedOptions, field.key)}
                    />
                    ) : null}
                  </FormGroup>

                </div>
              </div>


            ))}

          <div className="d-flex justify-content-end">
            <Button
              variant="contained"
              type="submit"
              style={{ marginBottom: "50px" }}
            >
              <span>Save</span>
            </Button>
            <br></br>
            <br></br>
            <br></br>
          </div>
        </form>
      </div>
    </>
  );
}
